module.exports = __webpack_public_path__ + "media/ding.8bcd44d4.wav";